import { createSlice } from '@reduxjs/toolkit'
import {
  cashoutThunk,
  getBetsHistoryThunk,
  getCurrenctGameStateThunk,
  openedTileThunk,
  placeBetThunk
} from './towerGame.thunk'

const initialState = {
  betResponse: null,
  openedTileResponse: null,
  cashoutResponse: null,
  currentGameStateResponse: null,
  betHistoryResponse: { count: 0, rows: [] },
  // loader
  betResponseLoading: false,
  currenctGameStateLoading: false,
  betHistoryResponseLoading: false
}

const {
  actions: { setPlacedBetsData },
  reducer
} = createSlice({
  name: 'towerGame',
  initialState,
  reducers: {
    setPlacedBetsData: (state, { payload }) => {
      return {
        ...state,
        betHistoryData: [payload, ...state.betHistoryData]
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBetsHistoryThunk.pending, (state, { payload }) => {
        return {
          ...state,
          betHistoryResponseLoading: true
        }
      })
      .addCase(getBetsHistoryThunk.fulfilled, (state, { payload }) => {
        return {
          ...state,
          betHistoryResponseLoading: false,
          betHistoryResponse: payload
        }
      })
      .addCase(getBetsHistoryThunk.rejected, (state, { payload }) => {
        return {
          ...state,
          betHistoryResponseLoading: false
        }
      })
      .addCase(getCurrenctGameStateThunk.pending, (state, { payload }) => {
        return {
          ...state,
          currenctGameStateLoading: true
        }
      })
      .addCase(getCurrenctGameStateThunk.fulfilled, (state, { payload }) => {
        return {
          ...state,
          currenctGameStateLoading: false,
          currentGameStateResponse: payload
        }
      })
      .addCase(getCurrenctGameStateThunk.rejected, (state, { payload }) => {
        return {
          ...state,
          currenctGameStateLoading: false
        }
      })
      .addCase(placeBetThunk.pending, (state, { payload }) => {
        return {
          ...state,
          betResponseLoading: true
        }
      })
      .addCase(placeBetThunk.fulfilled, (state, { payload }) => {
        return {
          ...state,
          betResponse: payload,
          betResponseLoading: false
        }
      })
      .addCase(placeBetThunk.rejected, (state, { payload }) => {
        return {
          ...state,
          betResponseLoading: false
        }
      })
      .addCase(openedTileThunk.fulfilled, (state, { payload }) => {
        return {
          ...state,
          ...(payload?.result && {
            betHistoryResponse: {
              ...state.betHistoryResponse,
              rows: [payload, ...state.betHistoryResponse.rows]
            }
          }),
          openedTileResponse: payload
        }
      })
      .addCase(cashoutThunk.fulfilled, (state, { payload }) => {
        return {
          ...state,
          cashoutResponse: payload,
          ...(payload?.result && {
            betHistoryResponse: {
              ...state.betHistoryResponse,
              rows: [payload, ...state.betHistoryResponse.rows]
            }
          })
        }
      })
  }
})

export default reducer
export { setPlacedBetsData }
